import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Autosuggest from "react-autosuggest";
import countries from "i18n-iso-countries";
import UnifiedModal from "../UnifiedModal";
import "./styles.scss";

const ResidencyModal = ({ show, onHide, onSelect }) => {
  const { t, i18n } = useTranslation();
  const [suggestions, setSuggestions] = useState([]);
  const [query, setQuery] = useState("");
  const inputRef = useRef();

  useEffect(() => {
    // Register locale dynamically
    try {
      const localeModule = require(`i18n-iso-countries/langs/${i18n.language}.json`);
      countries.registerLocale(localeModule);
    } catch (e) {
      // Fallback to English if locale not found
      const enModule = require("i18n-iso-countries/langs/en.json");
      countries.registerLocale(enModule);
    }
  }, [i18n.language]);

  useEffect(() => {
    // Show all suggestions initially
    onSuggestionsFetchRequested({ value: '' });
  }, []);

  useEffect(() => {
    if (show) {
      setQuery("");
      setSuggestions(getSuggestions(''));
    }
  }, [show]);

  const getSuggestions = (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    const countryNames = countries.getNames(i18n.language);
    const allCountries = Object.entries(countryNames).map(([code, name]) => ({ code, name }));

    if (inputLength === 0) {
      return allCountries; // Show all countries when input is empty
    }

    const filtered = allCountries.filter(({code, name}) =>
      name.toLowerCase().includes(inputValue)
    );

    return filtered;
  };

  const getSuggestionValue = (suggestion) => suggestion.name;

  const renderSuggestion = (suggestion) => <div>{suggestion.name}</div>;

  const onSuggestionsFetchRequested = ({ value }) => {
    setSuggestions(getSuggestions(value));
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const onSuggestionSelected = (event, { suggestion }) => {
    onSelect(suggestion.code);
    onHide();
  };

  const onChange = (event, { newValue }) => {
    setQuery(newValue);
  };

  useEffect(() => {
    // Show all suggestions initially
    setSuggestions(getSuggestions(''));
  }, []);

  const handleEntered = () => {
    console.log('Modal entered');
    if (inputRef.current) {
      console.log('Focusing input');
      inputRef.current.focus();
    } else {
      console.log('inputRef.current is null');
    }
  };

  return (
    <UnifiedModal
      show={show}
      onHide={onHide}
      title={t("selectResidency")}
      dir={i18n.dir()}
      onEntered={handleEntered}
      bodyStyle={{ minHeight: '65vh' }}
    >
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        onSuggestionSelected={onSuggestionSelected}
        alwaysRenderSuggestions={true}
        theme={{
          suggestionsContainer: 'suggestions-container',
          suggestionsList: 'suggestions-list',
        }}
        inputProps={{
          placeholder: t("searchCountry"),
          value: query,
          onChange: onChange,
          className: "form-control",
          type: "search",
          ref: inputRef,
        }}
      />
    </UnifiedModal>
  );
};

export default ResidencyModal;